package ui.new_ui.components.find_teacher_page

import emotion.react.css
import helpers.PropsWithCss
import kotlinx.css.progress
import react.FC
import react.Props
import react.dom.html.ReactHTML
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent

external interface FindTeacherPlacesAll: PropsWithCss{
    var prefix: String
}

external interface FindTeacherPlacesAfterProps: FindTeacherPlacesAll{
    var after: String/*аудитория где был*/
    var time: String
}
external interface FindTeacherPlacesBeforeProps: FindTeacherPlacesAll{
    var before: String/*аудитория где будет*/
    var time: String
}
external interface FindTeacherPlacesInProps: FindTeacherPlacesAll{
    var `in`: String/*аудитория где сейчас*/
    var time: String
}
external interface FindTeacherPlacesBetweenProps: FindTeacherPlacesAll{
    var was: String/*аудитория где был*/
    var timeWas: String
    var be: String/*аудитория где будет*/
    var timeBe: String
}

object FindTeacherHelpers {


    val FindTeacherPlacesAfter = FC<FindTeacherPlacesAfterProps>{props->
        ReactHTML.div{
            css {
                display = Display.flex
                flexDirection = FlexDirection.column
            }

            ReactHTML.span{
                css {
                    props.css(this)
                }
                +"${props.prefix} в ${props.after}"
            }
            ReactHTML.span{
                css {
                    props.css(this)
                }
                +props.time
            }
        }
    }
    val FindTeacherPlacesBefore = FC<FindTeacherPlacesBeforeProps>{props->
        ReactHTML.div{
            css {
                display = Display.flex
                flexDirection = FlexDirection.column
            }

            ReactHTML.span{
                css {
                    props.css(this)
                }
                +"Будет в ${props.before}"
            }
            ReactHTML.span{
                css {
                    props.css(this)
                }
                +props.time
            }
        }
    }
    val FindTeacherPlacesIn = FC<FindTeacherPlacesInProps>{props->
        ReactHTML.div{
            css {
                display = Display.flex
                flexDirection = FlexDirection.column
            }

            ReactHTML.span{
                css {
                    props.css(this)
                }
                +"Сейчас в ${props.`in`}"
            }
            ReactHTML.span{
                css {
                    props.css(this)
                }
                +props.time
            }
        }
    }
    val FindTeacherPlacesBetween = FC<FindTeacherPlacesBetweenProps>{props->
        ReactHTML.div{
            css {
                display = Display.flex
                flexDirection = FlexDirection.row
                justifyContent = JustifyContent.spaceBetween
            }

            ReactHTML.div{
                css {
                    display = Display.flex
                    flexDirection = FlexDirection.column
                }

                ReactHTML.span{
                    css {
                        props.css(this)
                    }
                    +"${props.prefix} в ${props.was}"
                }
                ReactHTML.span{
                    css {
                        props.css(this)
                    }
                    +props.timeWas
                }
            }
            ReactHTML.div{
                css {
                    display = Display.flex
                    flexDirection = FlexDirection.column
                }

                ReactHTML.span{
                    css {
                        props.css(this)
                    }
                    +"Будет в ${props.be}"
                }
                ReactHTML.span{
                    css {
                        props.css(this)
                    }
                    +props.timeBe
                }
            }
        }
    }

    val FindTeacherPlacesNone = FC<FindTeacherPlacesAll> {props->
        ReactHTML.span{
            css {
                props.css(this)
            }
            +"Сегодня не в колледже"
        }
    }
}